import SvgIcon from '@mui/material/SvgIcon';
import useTheme from '@mui/material/styles/useTheme';
import { DEV } from 'esm-env';
import {
  cloneElement,
  ComponentType,
  forwardRef,
  memo,
  ReactElement,
  Ref,
  SVGAttributes,
} from 'react';
import { IconProps } from './types';

type StrictProps = Omit<IconProps, 'component' | 'sx'>;

export default function createSvgIcon(
  path24: string | ReactElement<SVGAttributes<SVGPathElement>>,
  displayName: string,
  path16: string | ReactElement<SVGAttributes<SVGPathElement>>,
  rtlFlip: boolean,
): ComponentType<StrictProps> {
  const Component = memo(
    forwardRef(({ intrinsicSize, ...props }: StrictProps, ref: Ref<SVGSVGElement>) => {
      const pathSize = intrinsicSize || props.fontSize === 'small' ? 16 : 24;
      const path = pathSize === 16 && path16 ? path16 : path24;
      const viewBox = !path16 ? 24 : pathSize;
      const pathElem = typeof path === 'string' ? <path d={path} /> : path;
      const shouldRtlFlip = useTheme().direction === 'rtl' && rtlFlip;

      return (
        <SvgIcon ref={ref} {...props} viewBox={`0 0 ${viewBox} ${viewBox}`}>
          {shouldRtlFlip
            ? cloneElement(pathElem, {
                ...pathElem.props,
                style: { transformOrigin: 'center', transform: 'scaleX(-1)' },
              })
            : pathElem}
        </SvgIcon>
      );
    }),
  );

  if (DEV) {
    Component.displayName = displayName;
  }

  return Component;
}
